export const themeConfig = {
  themeColor: "pink",
  direction: "ltr",
  mode: "light",
  locale: "en",
  primaryColorLevel: 500,
  cardBordered: false,
  panelExpand: false,
  controlSize: "md",
  navMode: "light",
  layout: {
    type: "classic",
    sideNavCollapse: false,
  },
};
